module.exports = __webpack_public_path__ + "fonts/Lato-Light.cf44fd55.ttf";